import React from 'react';
import classes from './ChooseBlock.module.css';

interface IChooseBlockProps {
  image: string;
  title: string;
  content: string;
}

export default function ChooseBlock({
  image,
  title,
  content,
}: IChooseBlockProps) {
  return (
    <div className={classes.block}>
      <img src={image} alt={title} />
      <div className={classes.text}>
        <h3 className="text-smTitlesForH md:text-mdTitlesForH lg:text-lgTitlesForH">
          {title}
        </h3>
        <p className="text-smAddTxt md:text-mdAddTxt lg:text-lg2AddTxt">
          {content}
        </p>
      </div>
    </div>
  );
}
